'use client';

/* eslint-disable @next/next/no-img-element */
import classNames from '@sindresorhus/class-names';
import {COOKIE_FEATURING_WITH_BACK_BUTTON, setCookie} from '@utils/cookies';
import {useEnvConfig} from '@web-catalog/env';
import Link from 'next/link';
import {useCallback, useRef} from 'react';

import {
  AppsSelectionWithoutContent,
  SelectionWithCovers,
} from '@web-catalog/types';

import {
  useLogCompilationCardClick,
  useLogOnCompilationShow,
} from '@web-catalog/utils/analytics/interestingPage';

import styles from './SelectionCard.module.scss';

type Props = {
  selection: AppsSelectionWithoutContent;
  strapiConfig: SelectionWithCovers;
  cardNumber: number;
  className?: string;
};

export const SelectionCard = ({
  selection,
  strapiConfig: config,
  cardNumber,
  className,
}: Props) => {
  const {COOKIE_DOMAIN} = useEnvConfig();
  const ref = useRef(null);

  useLogOnCompilationShow({ref, selection, selectionNumber: cardNumber});
  const logClick = useLogCompilationCardClick();

  const onClick = useCallback(() => {
    setCookie(COOKIE_FEATURING_WITH_BACK_BUTTON, selection.id, COOKIE_DOMAIN);
    logClick(selection, cardNumber);
  }, [selection, cardNumber, COOKIE_DOMAIN, logClick]);

  return (
    <Link
      ref={ref}
      href={`/featuring/${selection.id}`}
      prefetch={false}
      className={className}
      onClick={onClick}
    >
      <div className={styles.root}>
        <img
          className={styles.background}
          src={selection.imageUrl}
          loading="lazy"
          alt={`Обложка подборки ${selection.title?.value ?? ''}`}
        />
        {config.coverOverlayColor && (
          <div
            className={styles.overlay}
            style={{'--color': config.coverOverlayColor} as React.CSSProperties}
          />
        )}
        {selection.subtitle?.value && (
          <div
            className={classNames(
              styles.subtitle,
              config.textColorType === 'light' && styles.light,
            )}
          >
            {selection.subtitle.value}
          </div>
        )}
        {selection.title?.value && (
          <div
            className={classNames(
              styles.title,
              config.textColorType === 'light' && styles.light,
            )}
          >
            {selection.title.value}
          </div>
        )}
      </div>
    </Link>
  );
};
